import useLoginCheck from 'hooks/common/useLoginCheck';
import { getErrorList } from 'lib/api/error';
import { changeError, changeLoading } from 'modules/errorSlice';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

const useErrorDashboardTable = done => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const [currentPage, setCurrentPage] = useState(1);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [sortType, setSortType] = useState('createdAt');
  const [sortDirection, setSortDirection] = useState('desc');
  const [filterTitle, setFilterTitle] = useState('');
  const [filterName, setFilterName] = useState('');

  const { isLoading, error, data, refetch } = useQuery(
    [
      'errorList',
      done,
      currentPage,
      searchKeyword,
      sortType,
      sortDirection,
      filterName,
      filterTitle,
    ],
    () =>
      getErrorList({
        page: currentPage,
        orderBy: done ? sortType : 'createdAt',
        orderDir: sortDirection,
        isDone: done ? 1 : 0,
        filterName,
        filterTitle,
        searchKeyword,
      }),
    {
      keepPreviousData: true,
      onError: error => {
        if (error?.response.status === 500) {
          dispatch(changeError(true));
        }
        dispatch(changeLoading({ id: 'errorList', sign: -1 }));
      },
      onSuccess: () => {
        dispatch(changeLoading({ id: 'errorList', sign: -1 }));
      },
    },
  );
  useLoginCheck(error?.response, refetch);
  const errorList = data?.data.result;
  const count = data?.data.count;

  useEffect(() => {
    if (
      isLoading ||
      error?.response.status === 401 ||
      error?.response.data.error === 'AuthorizationNotFound'
    ) {
      dispatch(changeLoading({ id: 'errorList', sign: 1 }));
    }
  }, [isLoading, error?.response.status, error?.response.data.error, dispatch]);

  useEffect(() => {
    setCurrentPage(1);
  }, [pathname]);

  const onChangeSearchKeyword = e => {
    setSearchKeyword(e.target.value);
    setCurrentPage(1);
  };

  const onSortByUpdatedAt = () => {
    setSortType('doneAt');
    if (sortDirection === 'desc') {
      setSortDirection('asc');
    } else {
      setSortDirection('desc');
    }
  };

  const onSortByCreatedAt = () => {
    setSortType('createdAt');
    if (sortDirection === 'desc') {
      setSortDirection('asc');
    } else {
      setSortDirection('desc');
    }
  };

  return {
    currentPage,
    searchKeyword,
    errorList,
    count,
    filterTitle,
    filterName,
    setCurrentPage,
    setFilterTitle,
    setFilterName,
    onSortByCreatedAt,
    onSortByUpdatedAt,
    onChangeSearchKeyword,
  };
};

export default useErrorDashboardTable;
